<template>
<div class="flexpage" @click="navOn = false">
	<div class="flexhead">
	    <van-nav-bar :title="$store.state.app.appname" left-text="" />
	</div>
	<div class="flexContent">
		<div class="topnav">
			<ul>
				<li v-if="nowChooseID == item.id" :class="{active:nowChooseID == item.id}" @click.stop="clickNavFirst(item)" :ids="item.id"  :key="item.id" v-for="item in allNavData.class_list"><span>{{item.short_name}}</span>
				</li>
			</ul>
		</div>
		<div class="theSwipe">
			<van-swipe :autoplay="5000" indicator-color="white">
				<van-swipe-item v-for="item in bannerRow" :key="item.id"><router-link :to="{path:item.url}"><img :src="item.image" alt=""></router-link></van-swipe-item>
			</van-swipe>
		</div>
		<div class="secNav wrap">
			<span class="secNavShadow" v-if="childNavList.length > 3"></span>
			<div class="secNavCon">
				<ul>
					<li :class="{active:nowChooseChildID==0}" @click="clickNavChild(0)">全部</li>
					<li :class="{active:nowChooseChildID==item.id}" @click="clickNavChild(item.id)" v-for="item of childNavList" >{{item.short_name}}</li>
				</ul>
			</div>
		</div>
		<ul class="prolist">
				<li v-for="item in videoList" :key="item.id" @click="$router.push({name:'sourse',query:{istypelist:'yes'},params:{id:item.id,nowChooseID:nowChooseID,nowChooseChildID:nowChooseChildID}})">
					<img class="proimg" :src="item.img_2" alt="">
					<div class="prodes">
						<h5>{{item.name}}</h5>
					</div>
				</li>
		</ul>
		<div class="p5 center" v-if="videoList.length<1">暂无数据</div>
	</div>
</div>
</template>
<script>
export default {
	data(){
    	return {
    		bannerRow:[],
    		videoList:[],
    		nowpage:1,	 //
			pagerow:100,

		    //一二级名称等
		    allNavData:{
		    	class_list:[]
		    },
		    nowChooseID:0,
		    nowChooseChildID:0,
		    childNavList:[]
    	}
    },
  	components:{},
  	watch:{},
  	computed:{
  		// childNavList(){
  		// 	for(let i of this.allNavData.class_list){
  		// 		if(i.id == this.nowChooseID){
  		// 			return i.child;
  		// 		}
  		// 	}
  		// 	return []
  		// }
  	},
	mounted(){
		//页面初始化完成
		this.pageInit()
	},

	methods:{
		pageInit(){
			this.getHomeALL();
		},
		//=========获取“全部”
		getHomeALL(){
			var _self = this;
			_self.$mts.get({
				url:"Openvideo/getHome/",
				data:{},
				success(res){
					 console.log(res.data.data)
					_self.allNavData = res.data.data;


					if(_self.$route.params.typeid){
						for(let i=0;i<_self.allNavData.class_list.length;i++){
							if(_self.allNavData.class_list[i].id == _self.$route.params.typeid){
								_self.clickNavFirst(_self.allNavData.class_list[i]);
								_self.getAllChildVideo(_self.allNavData.class_list[i].id);
								_self.$store.state.app.onlytype == true;
							}
						}

					}else{
						_self.clickNavFirst(_self.allNavData.class_list[0]);
						_self.getAllChildVideo(_self.allNavData.class_list[0].id)
					}
                },
                error(error){}
			})

		},
		//=========点击一级导航
		clickNavFirst(item){
	    	this.nowChooseID = item.id;

			var _self = this;
			_self.$mts.get({
				url:"Openvideo/getbanner/class/"+item.id,
				data:{},
				success(response){
                    _self.bannerRow = response.data.data;
                },
                error(error){}
			})
			this.getAllChildVideo(item.id)

		},
		clickNavChild(id){
			this.nowChooseChildID = id;
			var _self = this;


			if(id==0){ //全部
				this.getAllChildVideo(this.nowChooseID)
			}else{
				_self.$mts.post({
					url:"Openvideo/getHomeBysId/",
					data:{
						pid:id,	
						page:_self.nowpage,  //分页
						rows:_self.pagerow, //每页数量
						s:'t', //t=更新时间；n=视频数量；空=默认
						o:'a' //a=升序；d=降序(默认);
					},
					success(response){
	                    _self.videoList = response.data.data;
	                },
	                error(error){}
				})
			}
		},
		getAllChildVideo(id){
			var _self = this;
			_self.$mts.get({
				url:"Openvideo/getHome/class/"+id,
				data:{},
				success(res){
					for(let i of res.data.data.class_list){
		  				if(i.id == id){
		  					_self.childNavList = i.child;
		  				}
		  			}
                    _self.nowChooseChildID = 0;
                    _self.videoList = res.data.data.list
                },
                error(error){}
			})
		},
	}
}
</script>
